const API_BASE = (process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010').replace(/\/$/, '');
const REFRESH_URL = `${API_BASE}/api/auth/refresh`;

let isRefreshing = false;
let pendingQueue = [];

const processQueue = (newToken) => {
  pendingQueue.forEach(({ resolve, input, init }) => {
    const retryInit = {
      ...init,
      headers: { ...(init?.headers || {}), Authorization: `Bearer ${newToken}` },
    };
    resolve(window.__originalFetch(input, retryInit));
  });
  pendingQueue = [];
};

const rejectQueue = () => {
  pendingQueue.forEach(({ reject }) => reject(new Error('Session expired')));
  pendingQueue = [];
};

const doRefresh = async () => {
  const refreshToken = sessionStorage.getItem('authRefreshToken');
  if (!refreshToken) return null;

  const resp = await window.__originalFetch(REFRESH_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken }),
  });

  if (!resp.ok) return null;

  const data = await resp.json();
  sessionStorage.setItem('authToken', data.token);
  sessionStorage.setItem('authRefreshToken', data.refreshToken);
  return data.token;
};

const redirectToLogin = () => {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('authRefreshToken');
  sessionStorage.removeItem('authUsername');
  sessionStorage.removeItem('authRole');
  sessionStorage.removeItem('authTenantUserMode');
  window.location.href = '/login';
};

export const installFetchInterceptor = () => {
  if (window.__originalFetch) return;
  window.__originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input instanceof Request ? input.url : String(input);

    if (url.includes('/api/auth/')) {
      return window.__originalFetch(input, init);
    }

    const response = await window.__originalFetch(input, init);

    if (response.status !== 401) return response;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject, input, init });
      });
    }

    isRefreshing = true;

    try {
      const newToken = await doRefresh();
      isRefreshing = false;

      if (!newToken) {
        rejectQueue();
        redirectToLogin();
        return response;
      }

      processQueue(newToken);

      const retryInit = {
        ...init,
        headers: { ...(init?.headers || {}), Authorization: `Bearer ${newToken}` },
      };
      return window.__originalFetch(input, retryInit);
    } catch {
      isRefreshing = false;
      rejectQueue();
      redirectToLogin();
      return response;
    }
  };
};
